import { zodResolver } from '@hookform/resolvers/zod';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import * as z from 'zod';
import { isSupabaseError } from '../../../../constants/supabaseErrors';
import { ExpenseCategoryDatabase } from '../../../../types';
import { usePostExpenseCategory } from '../../api/usePostExpenseCategory';

const formSchema = z.object({
  name: z.string().trim().min(1, 'Donnez un nom à la catégorie'),
  description: z.string(),
});

type FormValues = z.infer<typeof formSchema>;

type Props = {
  onClose: () => void;
  afterSuccess?: (category: ExpenseCategoryDatabase) => void;
};

export function useExpenseCategoryFormDialog(props: Props) {
  const { mutateAsync, isPending } = usePostExpenseCategory();
  const [serverError, setServerError] = useState<string | null>(null);

  const form = useForm<FormValues>({
    resolver: zodResolver(formSchema),
    defaultValues: { name: '', description: '' },
  });

  async function handleSubmit(values: FormValues) {
    setServerError(null);

    try {
      const category = await mutateAsync(values);
      props.afterSuccess?.(category);
      props.onClose();
    } catch (error: unknown) {
      setServerError(
        isSupabaseError(error) || error instanceof Error
          ? error.message
          : 'La catégorie n\'a pas pu être créée. Réessayez.',
      );
    }
  }

  function handleClose() {
    if (!isPending) {
      props.onClose();
    }
  }

  return {
    form,
    onSubmit: form.handleSubmit(handleSubmit),
    isPending,
    serverError,
    handleClose,
  };
}
